import socket from './socket';

/* Actions */

const getInvoicesElectricity = (currentMonth, headers) =>
  socket.get(`/electricity-invoices/${currentMonth}`, undefined, headers);

const getInvoicesGas = (currentMonth, headers) =>
  socket.get(`/gas-invoices/${currentMonth}`, undefined, headers);

const getInvoicesWater = (currentMonth, headers) =>
  socket.get(`/water-invoices/${currentMonth}`, undefined, headers);

export default {
  getInvoicesElectricity,
  getInvoicesGas,
  getInvoicesWater,
};
